<template>
  <a-dropdown v-if="nickname" placement="bottomRight">
    <span class="ant-pro-account-avatar">
      <a-avatar
        size="small"
        :src="getAvatarSrc()"
        class="antd-pro-global-header-index-avatar"
      />
      <span class="nickname-text">{{ nickname }}</span>
      <img :src="getArrowImageUrl()" alt="arrow" class="nickname-arrow" />
    </span>
    <template v-slot:overlay>
      <a-menu class="ant-pro-drop-down menu" :selected-keys="[]">
        <!--        <a-menu-item v-if="menu" key="center" @click="handleToCenter">-->
        <!--          <a-icon type="user" />-->
        <!--          个人中心-->
        <!--        </a-menu-item>-->
        <a-menu-item v-if="menu" @click="handleToSettings">
          <SettingOutlined />
          个人设置
        </a-menu-item>
        <a-menu-divider v-if="menu" />
        <a-menu-item key="logout" @click="handleLogout">
          <LogoutOutlined />
          退出登录
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
  <span v-else>
    <a-spin size="small" :style="{ marginLeft: 8, marginRight: 8 }" />
  </span>
</template>

<script>
import { Modal } from 'ant-design-vue'
import { mapGetters } from 'vuex'
import { SettingOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons-vue'

export default {
  name: 'AvatarDropdown',
  components: {
    SettingOutlined,
    LogoutOutlined,
    UserOutlined,
  },
  props: {
    menu: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // 默认头像URL，在组件创建时初始化
      defaultAvatarUrl: require('@/assets/avatar.png'),
      // 箭头图片
      arrowImage: require('@/assets/arrow.png'),
    }
  },
  computed: {
    ...mapGetters(['avatar', 'nickname']),
    // 处理头像 URL，确保能正确显示
    avatarUrl() {
      console.log('[AvatarDropdown] 当前头像值:', this.avatar, '类型:', typeof this.avatar)
      
      // 如果 avatar 为空、null、undefined 或空字符串，使用默认头像
      if (!this.avatar || this.avatar === '' || this.avatar === 'null' || this.avatar === 'undefined') {
        const defaultUrl = this.defaultAvatarUrl
        console.log('[AvatarDropdown] 使用默认头像:', defaultUrl)
        return defaultUrl
      }
      
      // 如果 avatar 是通过 require 或 import 加载的对象，需要提取实际的 URL
      if (typeof this.avatar === 'object' && this.avatar !== null) {
        // 可能是 { default: 'url' } 或直接的 URL 字符串
        let extractedUrl = this.avatar.default || this.avatar
        // 如果提取后仍然是对象，可能是模块对象，再次尝试提取
        while (typeof extractedUrl === 'object' && extractedUrl !== null && extractedUrl.default) {
          extractedUrl = extractedUrl.default
        }
        // 如果最终提取的是字符串，返回它
        if (typeof extractedUrl === 'string') {
          return extractedUrl
        }
        // 如果仍然是对象，尝试转换为字符串
        if (typeof extractedUrl === 'object' && extractedUrl !== null) {
          // 可能是 webpack 处理后的模块，尝试获取其字符串表示
          const urlStr = String(extractedUrl)
          if (urlStr && urlStr !== '[object Object]') {
            return urlStr
          }
        }
      }
      
      // 如果是完整的 URL，直接返回
      if (typeof this.avatar === 'string' && (this.avatar.startsWith('http://') || this.avatar.startsWith('https://'))) {
        return this.avatar
      }
      
      // 如果是相对路径（以 / 开头），直接返回（需要后端支持）
      if (typeof this.avatar === 'string' && this.avatar.startsWith('/')) {
        return this.avatar
      }
      
      // 其他情况：如果是字符串但不是URL，也可能是有效的图片路径，直接返回
      if (typeof this.avatar === 'string' && this.avatar) {
        return this.avatar
      }
      
      // 如果都不匹配，返回默认头像
      console.log('[AvatarDropdown] 未匹配到有效头像，使用默认头像')
      return this.defaultAvatarUrl
    },
    // 判断是否有有效的头像 URL
    hasValidAvatar() {
      const url = this.avatarUrl
      return url && url !== '' && url !== 'null' && url !== 'undefined'
    },
  },
  methods: {
    // 获取默认头像的实际 URL
    getDefaultAvatarUrl() {
      const defaultAvatar = this.defaultAvatarUrl
      if (defaultAvatar && typeof defaultAvatar === 'object' && defaultAvatar.default) {
        return defaultAvatar.default
      }
      if (typeof defaultAvatar === 'string') {
        return defaultAvatar
      }
      // 如果是对象，尝试提取
      if (defaultAvatar) {
        return String(defaultAvatar)
      }
      return ''
    },
    // 提取用户头像的实际 URL
    extractUserAvatarUrl(userAvatar) {
      if (!userAvatar || userAvatar === '' || userAvatar === 'null' || userAvatar === 'undefined') {
        return null
      }
      
      // 如果是对象类型（可能是 require 加载的模块）
      if (typeof userAvatar === 'object' && userAvatar !== null) {
        let extractedUrl = userAvatar.default || userAvatar
        // 递归提取嵌套的对象
        while (typeof extractedUrl === 'object' && extractedUrl !== null && extractedUrl.default) {
          extractedUrl = extractedUrl.default
        }
        // 如果最终提取的是字符串，返回它
        if (typeof extractedUrl === 'string') {
          return extractedUrl
        }
        // 如果仍然是对象，尝试转换为字符串
        const urlStr = String(extractedUrl)
        if (urlStr && urlStr !== '[object Object]') {
          return urlStr
        }
      }
      
      // 如果是字符串类型
      if (typeof userAvatar === 'string') {
        // 如果是完整的 URL，直接返回
        if (userAvatar.startsWith('http://') || userAvatar.startsWith('https://')) {
          return userAvatar
        }
        // 如果是相对路径或其他有效路径，直接返回
        if (userAvatar.startsWith('/') || userAvatar.includes('.')) {
          return userAvatar
        }
        // 其他字符串情况，如果非空，返回
        if (userAvatar) {
          return userAvatar
        }
      }
      
      return null
    },
    // 获取头像源地址：优先使用用户头像，没有则使用默认头像
    getAvatarSrc() {
      // 先尝试获取用户头像
      const userAvatarUrl = this.extractUserAvatarUrl(this.avatar)
      if (userAvatarUrl) {
        console.log('[AvatarDropdown] 使用用户头像:', userAvatarUrl)
        return userAvatarUrl
      }
      
      // 如果没有用户头像，使用默认头像
      const defaultUrl = this.getDefaultAvatarUrl()
      console.log('[AvatarDropdown] 使用默认头像:', defaultUrl)
      return defaultUrl
    },
    // 获取箭头图片的 URL
    getArrowImageUrl() {
      const arrowImage = this.arrowImage
      if (arrowImage && typeof arrowImage === 'object' && arrowImage.default) {
        return arrowImage.default
      }
      if (typeof arrowImage === 'string') {
        return arrowImage
      }
      // 如果是对象，尝试转换为字符串
      if (arrowImage) {
        return String(arrowImage)
      }
      return ''
    },
    handleToCenter() {
      this.$router.push({ path: '/account/center' })
    },
    handleToSettings() {
      this.$router.push({ path: '/account/settings' })
    },
    handleLogout(e) {
      Modal.confirm({
        title: '提示',
        content: '确定注销并退出系统吗？',
        onOk: () => {
          return this.$store.dispatch('Logout').then(() => {
            location.href = '/index'
          })
        },
        onCancel() {},
      })
    },
  },
}
</script>

<style lang="less" scoped>
.ant-pro-drop-down {
  /deep/ .action {
    margin-right: 8px;
  }
  /deep/ .ant-dropdown-menu-item {
    min-width: 160px;
  }
}

// 默认头像图标样式 - 白色（蓝色背景）
.default-avatar-icon {
  color: #ffffff !important;
  font-size: 16px;
}

// 容器样式 - 确保内部元素垂直居中对齐
.ant-pro-account-avatar {
  display: flex;
  align-items: center;
  gap: 6px;
}

// 名称文字样式 - 垂直居中对齐
.nickname-text {
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

// 箭头图片样式 - 与文字垂直居中对齐
.nickname-arrow {
  width: 12px;
  height: 12px;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}
</style>

<style>
/* Confirm 弹窗按钮样式 - 全局样式确保生效（confirm弹窗是动态创建的） */
.ant-modal-confirm .ant-modal-confirm-btns .ant-btn {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-default {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
  color: #FFFFFF !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:focus:not(:disabled) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:active:not(:disabled) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}
</style>
